module.exports = __webpack_public_path__ + "img/introduction.4d64e174.png";